export const blockIconsHardwarePrintNew = (
	<span className='material-symbols-outlined'>print</span>
);
